<template>
  <!-- Dialog Copy Idea -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="400px"
    empty-header
    @close="hideDialogCopyIdea"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/copy-note.svg')"
      :title="$t('dialogs.copyIdea.title')"
      title-width="220px"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('yes')"
        :cancel-btn-text="$t('cancel')"
        :loading="loading"
        @cancel="hideDialogCopyIdea"
        @submit="copyIdea"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Copy Idea -->
</template>

<script>
export default {
  name: 'DialogCopyIdea',

  props: {
    visible: {
      default: false,
      type: Boolean
    },

    hideDialogCopyIdea: {
      type: Function,
      default: function () {}
    },

    copyIdea: {
      type: Function,
      default: function () {}
    }
  },

  data () {
    return {
      loading: false
    }
  }
}
</script>
